import getApiMiddlewares from '~packages/json-api/client/middlewares/getApiMiddlewares';
import { useAlerts } from '~packages/mkskom-utils/useAlerts';

import { getVars } from '@/shared/constants/envVars';

import { apiServices } from './../services';

const { setAlert } = useAlerts();

const middlewares = getApiMiddlewares(
  JSON.parse(getVars()?.VITE_API_SETTINGS || '{}'),
  apiServices,
  setAlert
);

// console.log('middlewares!', middlewares);
export default middlewares;
